import * as Sentry from '@sentry/browser'
import { getAuth } from 'firebase/auth'
import { nanoid } from 'nanoid'
import { kUserLogoutPath } from '@/constants/constants-api-paths'
import { kPaxtonAppApiRESTBaseUrl } from '@/constants/constants-links'
import firebase_app from '@/firebase/firebase-config'
import { ApiError } from '@/util/errors/api-error'

/**
 * Revokes every session for the signed-in user on the server, including other devices and
 * add-ins. Call before Firebase signOut, while the ID token is still available.
 * Resolves without a request when nobody is signed in.
 */
export default async function postLogout(): Promise<void> {
  const token = await getAuth(firebase_app).currentUser?.getIdToken()
  if (!token) return

  const sentryTransactionId = nanoid()
  const apiUrl = `${kPaxtonAppApiRESTBaseUrl()}${kUserLogoutPath}`
  try {
    const response = await fetch(apiUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json; charset=UTF-8',
        'X-Transaction-Id': sentryTransactionId,
        Authorization: `Bearer ${token}`,
      },
    })
    if (response.status !== 204) throw new ApiError(response.status, `Sign-out revocation failed: ${response.status}`)
  } catch (error) {
    Sentry.withScope((scope) => {
      scope.setTags({ transaction_id: sentryTransactionId })
      Sentry.captureException(error, { extra: { requestUrl: apiUrl } })
    })
    throw error
  }
}
